import { GraphStyle } from "../../types/models/AssetSymbol";
import { StickSvg } from "../../assets/svg/StickSvg";
import { GraphSolidSvg } from "../../assets/svg/GraphSolidSvg";
import { GraphOutlineSvg } from "../../assets/svg/GraphOutlineSvg";
import { CandleStickSvg } from "../../assets/svg/CandleStickSvg";
import React from "react";

interface GraphIconProps {
  graph: GraphStyle;
}

const GraphIcon: React.FC<GraphIconProps> = ({ graph }) => {
  console.log("graph", graph);

  switch (graph) {
    case "1":
      return <StickSvg />;
    case "2":
      return <GraphSolidSvg />;
    case "3":
      return <GraphOutlineSvg />;
    case "9":
      return <CandleStickSvg />;
    default:
      return <StickSvg />;
  }
};

export default GraphIcon;
